<div class="company-switcher-page">
    <div class="modal-container">
        <!-- 1. Top Orange Header -->
        <div class="header-banner orange-bg" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="banner-title">{{ getTranslated('Companies') }}</span>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
                <button (click)="onCancel()" class="close-btn" aria-label="Close" [matTooltip]="getTranslated('Close')">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <!-- 2. Blue Welcome Bar -->
        <div class="header-banner blue-bg" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="welcome-text">{{ getTranslated('Welcome') }} {{ userName ? userName : '' }} !</span>
            <span class="date-text">{{ currentDate | date:'EEE, dd MMM yyyy' }}</span>
        </div>

        <!-- 3. Selection Banner -->
        <div class="selection-banner-wrapper">
            <div class="selection-banner">
                <span>{{ getTranslated('Select a General Contractor Company') }}</span>
            </div>
        </div>

        <!-- 4. Company List -->
        <div class="company-list">
            <div class="company-card" *ngFor="let company of companies" (click)="selectCompany(company)">
                <div class="card-inner-top" fxLayout="row" fxLayoutAlign="space-between center">
                    <span class="company-name">{{ company.company_name }}</span>
                    <mat-icon class="arrow-icon">arrow_circle_right</mat-icon>
                </div>
                <div class="card-inner-bottom">
                    <span *ngIf="company.last_login">{{ getTranslated('Last accessed date') }}: {{ company.last_login }}</span>
                    <span *ngIf="!company.last_login">{{ getTranslated('Last accessed date') }}: 10 Mar 2026</span>
                </div>
            </div>
        </div>
    </div>
</div>